import { Routes } from '@angular/router';
import {teamsTokenGuard} from "./guards/teams-token.guard";

export const routes: Routes = [
  // {
  //   path: 'oauth',
  //   loadComponent: () =>
  //     import('./auth/oauth/oauth.component')
  //       .then(m => m.OauthComponent)
  // },
  {
    path: 'auth-failed',
    loadComponent: () =>
      import('./auth/auth-error/auth-error.component')
        .then(m => m.AuthErrorComponent)
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.routes')
      .then(m => m.PagesRoutes),
    canActivate: [teamsTokenGuard]
  },
  {path: '', redirectTo: 'pages', pathMatch: 'full'},
  {path: '**', redirectTo: 'pages'},

];
